"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExportCriticalActionsRequestStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getExportCriticalActionsRequestStatus = (0, _getRequestStatus.default)(_actions.CriticalActionsApiActionTypes.EXPORT);
exports.getExportCriticalActionsRequestStatus = getExportCriticalActionsRequestStatus;